if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') {
          this.close();
        }
      });

      this.bindOverlayClose();
      this.setHeaderCartIconAccessibility();
    }

    bindOverlayClose() {
      const overlay = this.querySelector('#CartDrawer-Overlay');

      if (!overlay || overlay.dataset.closeBound === 'true') return;

      overlay.dataset.closeBound = 'true';

      overlay.addEventListener('click', (event) => {
        if (event.target === overlay) {
          this.close();
        }
      });
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');

      if (!cartLink || cartLink.dataset.drawerBound === 'true') return;

      cartLink.dataset.drawerBound = 'true';
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');

      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });

      cartLink.addEventListener('keydown', (event) => {
        if (event.code === 'Space' || event.code === 'Enter') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    open(triggeredBy) {
      if (triggeredBy) {
        this.setActiveElement(triggeredBy);
      }

      const cartDrawerNote = this.querySelector(
        '[id^="Details-"] summary'
      );

      if (
        cartDrawerNote &&
        !cartDrawerNote.hasAttribute('role')
      ) {
        this.setSummaryAccessibility(cartDrawerNote);
      }

      requestAnimationFrame(() => {
        this.classList.add('animate', 'active');
      });

      const drawerInner = this.querySelector('.drawer__inner');

      if (drawerInner) {
        setTimeout(() => {
          trapFocus(
            drawerInner,
            this.querySelector('.drawer__close') || drawerInner
          );
        }, 100);
      }

      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');

      const content = cartDrawerNote.nextElementSibling;

      if (content?.id) {
        cartDrawerNote.setAttribute('aria-controls', content.id);
      }

      cartDrawerNote.addEventListener('click', (event) => {
        const details = event.currentTarget.closest('details');

        event.currentTarget.setAttribute(
          'aria-expanded',
          String(!details.hasAttribute('open'))
        );
      });

      cartDrawerNote.parentElement?.addEventListener(
        'keyup',
        onKeyUpEscape
      );
    }

    renderContents(parsedState) {
      this.productId = parsedState.id;

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (
          !sectionElement ||
          !parsedState.sections?.[section.id]
        ) {
          return;
        }

        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      });

      this.bindOverlayClose();

      setTimeout(() => {
        this.open();
      }, 10);
    }

    getSectionInnerHTML(
      html,
      selector = '.shopify-section'
    ) {
      const parsedHTML = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const element = parsedHTML.querySelector(selector);

      return element ? element.innerHTML : '';
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionDOM(
      html,
      selector = '.shopify-section'
    ) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}

if (
  typeof CartItems !== 'undefined' &&
  !customElements.get('cart-drawer-items')
) {
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }
  }

  customElements.define(
    'cart-drawer-items',
    CartDrawerItems
  );
}